/**
 * Notification Service for RoulezPropre
 * 
 * To use a real service (Brevo, Twilio, etc.), replace the console.log 
 * logic with actual API calls in the 'send' function.
 */

const API_KEY = ""; // 🔑 Put your API Key here if using a direct API
const WEBHOOK_URL = ""; // 🌐 Or use a Webhook URL (Make.com, Zapier)

const sendNotification = async (to, subject, body, type = 'sms') => {
    console.log(`[Notification ${type.toUpperCase()}] To: ${to} | Subject: ${subject} | Body: ${body}`);

    // EXAMPLE: Calling an Automation Webhook (Simplest for No-Code)
    if (WEBHOOK_URL) {
        try {
            await fetch(WEBHOOK_URL, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ to, subject, body, type })
            });
        } catch (err) { console.error("Webhook failed", err); }
    }
};

export const notifyNewBooking = (apt) => {
    const msg = `Bonjour ${apt.client_nom}, votre demande de nettoyage pour le ${new Date(apt.date_heure).toLocaleString()} a bien été reçue. Nous revenons vers vous pour la confirmation !`;
    sendNotification(apt.client_telephone, "Réservation RoulezPropre", msg, 'sms');
    sendNotification(apt.client_email, "Votre demande RoulezPropre", msg, 'email');
};

export const notifyReminder24h = (apt) => {
    const msg = `Rappel : RoulezPropre intervient demain à ${new Date(apt.date_heure).getHours()}h pour votre véhicule. À demain !`;
    sendNotification(apt.client_telephone, "Rappel RDV RoulezPropre", msg, 'sms');
};

export const notifyStepProgress = (apt, step) => {
    if (step === "Finitions") {
        const msg = `✨ RoulezPropre : Nous sommes à l'étape des finitions sur votre véhicule. Il sera prêt dans quelques minutes !`;
        sendNotification(apt.client_telephone, "Suivi RoulezPropre", msg, 'sms');
    }
};

export const notifyBookingConfirmed = (apt) => {
    const msg = `✅ Votre rendez-vous RoulezPropre du ${new Date(apt.date_heure).toLocaleString()} est validé ! Notre expert sera présent à l'adresse indiquée.`;
    sendNotification(apt.client_telephone, "RDV Validé RoulezPropre", msg, 'sms');
};
